
import { IconButton, MenuButton, Modal } from '@descomplica/vue-components';
import Vue from 'vue';
import i18n from '@/i18n';

export default Vue.extend({
  components: {
    MenuButton,
    IconButton,
    Modal,
  },
  data() {
    return {
      isOptionsOpened: false as Boolean,
    };
  },
  computed: {
    optionsItems(): Array<Object> {
      return [
        {
          label: i18n.t('edit'),
          iconName: 'edit',
          clickHandler: this.editingComment,
        },
        {
          label: i18n.t('delete'),
          iconName: 'delete',
          clickHandler: this.openDeleteModal,
        },
      ];
    },
  },
  methods: {
    toggleCommentOptions() {
      this.isOptionsOpened = !this.isOptionsOpened;
    },
    openDeleteModal() {
      this.$emit('openDeleteModal');
    },
    editingComment() {
      this.$emit('editingComment');
    },
  },
});
